import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

import ScrollAnimation from 'components/ScrollAnimation';
import Gallery from 'src/components/Gallery/Gallery';
import Map from 'src/components/Map/Map';
import Transit from 'src/components/Transit/Transit';
import RegisterButton from 'src/components/RegisterButton';
import NextLine from 'src/components/NextLine';
import Header from 'src/components/Header';

import imgAerial from 'src/assets/images/neighbourhood/aerial.jpg';
import imgSkyTrain from 'src/assets/images/skytrain.png';
import imgBackgroundCircle from 'src/assets/images/background-circle.svg';

class Neighbourhood extends Component {
  render() {
    return (
      <Root>
        <Header
          image={imgAerial}
          smallText={'Our'}
          largeText={'Vibrant Future'}
        />

        <ScrollAnimation>
          <Content>
            <BackgroundCircle
              src={imgBackgroundCircle}
              alt="background circle"
            />
            <Text>
              A city of beginnings and a community of opportunity, New
              Westminster has an established history of providing every new
              generation with a rewarding way of life and a welcoming place to
              call home.
            </Text>
            <Gallery />
            <BackgroundCircle2
              src={imgBackgroundCircle}
              alt="background circle"
            />
          </Content>
        </ScrollAnimation>

        <ScrollAnimation>
          <Map />
        </ScrollAnimation>

        <ScrollAnimation>
          <ConnectedContent>
            <Skytrain src={imgSkyTrain} alt="Skytrain" />
            <h2>Connected Convenience</h2>
            <StyledText>
              Located in the heart of a pedestrian-orientated, transit-friendly
              community, 618 Carnarvon is conveniently set in the city’s
              entertainment and cultural district. A block from the animated{' '}
              <span>Columbia Street</span>, a five-minute walk from{' '}
              <span>two SkyTrain stations</span>, and mere steps to theatres and
              restaurants, its central location also means major destinations
              throughout the Lower Mainland are less than{' '}
              <span>30 minutes</span> away by SkyTrain or on-site car share.
            </StyledText>
            <Transit />
          </ConnectedContent>
        </ScrollAnimation>
        <NextLine text={'Next: The Building'} link={'building'} />
        <RegisterButton />
      </Root>
    );
  }
}

export default Neighbourhood;

const Root = styled.div`
  overflow-x: hidden;
`;

const Content = styled.div`
  margin: 115px 0 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  h2 {
    color: ${({ theme }) => theme.colorPrimary};
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
    margin: 20px 0;
  }
`;

const ConnectedContent = styled(Content)`
  margin: 40px 0 60px;
  h2 {
    margin: 40px 0 30px;
  }
  span {
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

const Text = styled.p`
  width: 80%;
  margin: 0 0 80px;
  font-family: ${({ theme }) => theme.fontMain};
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  opacity: 0.72;
  @media (min-width: ${media.smup}) {
    width: 40%;
  }
`;

const StyledText = styled(Text)`
  margin: 0 0 40px;
`;

const Skytrain = styled.img`
  width: 228px;
`;

const BackgroundCircle = styled.img`
  display: none;
  position: absolute;
  @media (min-width: ${media.sm}) {
    width: 30%;
    display: block;
    top: 50%;
    left: -5%;
    z-index: -1;
    opacity: 0.7;
  }
`;

const BackgroundCircle2 = styled(BackgroundCircle)`
  width: 35%;
  top: -20%;
  left: inherit;
  right: -15%;
  opacity: 0.7;
`;



// WEBPACK FOOTER //
// ./src/pages/Neighbourhood.js